import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Base64 } from 'js-base64';
import { PRODUCT_EXTRA_ENRICHMENT_FIELDS } from '../constants/extra';
export function enrichBannerExtra(extra, data) {
  if (!PRODUCT_EXTRA_ENRICHMENT_FIELDS.length || !data.bundleParams.htmlBase64) {
    return extra;
  }
  var parsedDecodedParams;
  try {
    var decodedParams = Base64.decode(data.bundleParams.htmlBase64);
    parsedDecodedParams = JSON.parse(decodedParams);
  } catch (error) {
    return extra;
  }
  if (!parsedDecodedParams || _typeof(parsedDecodedParams) !== 'object') {
    return extra;
  }
  return PRODUCT_EXTRA_ENRICHMENT_FIELDS.reduce(function (acc, el) {
    var value = parsedDecodedParams[el];
    if (value !== '' && value != null) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, el, value));
    }
    return acc;
  }, extra);
}